import { calendarService } from 'srcReact/services'
import { calWidgetConstant as cwc } from './constant'
export const calWidgetActions = {
  getMixrsOfGroupBetweenDays,
  setInitialState
}

function getMixrsOfGroupBetweenDays(groupId, startDate, endDate, quantity, longitude, latitude, ipAddress) {
  return (dispatch) => {
    dispatch(request({ groupId }))

    calendarService
      .getCalendarEventsOfGroup(groupId, startDate, endDate, quantity, longitude, latitude, ipAddress)
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(response) {
    return { type: cwc.GET_MIXRS_BTWN_DAYS_REQUEST, response }
  }
  function success(response) {
    return { type: cwc.GET_MIXRS_BTWN_DAYS_SUCCESS, response }
  }
  function failure(error) {
    return { type: cwc.GET_MIXRS_BTWN_DAYS_FAILURE, error }
  }
}

function setInitialState() {
  return { type: cwc.SET_INITIAL_STATE }
}
